export default "__VITE_ASSET__927bedd5__"